import { END_POINTS } from "../constants/url";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
};
type GetAllPayment = {
  list: any[];
  totalCount: number;
};

export const TaskApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getTask: builder.query<
      CommonResponseType & { data: GetAllPayment },
      {
        page: number;
        limit: number;
        search: string;
        status: number;
      }
    >({
      query: ({ search, page, limit, status }) => ({
        url: `${END_POINTS.Tasks}?search=${search}&page=${page}&limit=${limit}${
          status ? `&status=${status}` : ""
        }`,
        method: "GET",
      }),
    }),
  }),
});
export const { useLazyGetTaskQuery } = TaskApi;
